import script from "./exhibitionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./exhibitionsPage.vue?vue&type=script&setup=true&lang=js"

import "./exhibitionsPage.vue?vue&type=style&index=0&id=3a83d30b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a83d30b"]])

export default __exports__